export default __webpack_public_path__ + "static/media/googlebooks.acdb41d1.png";